import moment from "moment";
import styles from "./ClinicSessionTime.module.scss";
import { FormattedDate } from "react-intl";

const ClinicSessionTime = ({ clinic, session }) => {
    return (
        <time dateTime={moment(session?.start_date).toISOString()}>
            <span className={styles.Time}>
                <FormattedDate
                    value={session?.start_date}
                    timeZone={clinic?.timezone_id || undefined}
                    year="numeric"
                    month="numeric"
                    day="numeric"
                />
            </span>
            <FormattedDate
                value={session?.start_date}
                timeZone={clinic?.timezone_id || undefined}
                hour="2-digit"
                minute="2-digit"
                hourCycle="h12"
            />
            {clinic.timezone_abbreviation && <small className="ml-1 text-muted">({clinic.timezone_abbreviation})</small>}
        </time>
    );
}

export default ClinicSessionTime;